import { parseNumericValue } from '../parseNumericValue';

export const convertCelsiusToFahrenheit = (
  celsius: number,
  factionDigits = 1,
): string => {
  const fahrenheit = celsius * (9 / 5) + 32;
  return parseNumericValue(fahrenheit, factionDigits);
};
